import { apiClient, getAuthHeader } from "./apiConfig";

export const subscribeNewsletter = async (email) => {
  const res = await apiClient.post(
    `/newsletter/create`,
    { email },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const fetchNewsletterSubscribers = async () => {
  const res = await apiClient.get(`/newsletter/get_all`, getAuthHeader());
  return res.data?.data || [];
};

export const deleteNewsletterSubscriber = async (id) => {
  return apiClient.delete(`/newsletter/delete/${id}`, getAuthHeader());
};
